module.exports = __webpack_public_path__ + "img/card7.f1e292d1.png";